import { AIGeneratorName, AISourceType } from "../entryes/panel/AI/types";
import http from "./client";


export interface AIRequestTextParamsInterface {
  text: string;
}

export interface AIRequestLessonParamsInterface {
  lesson_id: string | number;
  questions?: number;
  variants?: number;
}


export interface AIRequestInterface {
  course_id: string | number;
  name: AIGeneratorName,
  source_type: AISourceType,
  source_id: string | number,
  data?:  AIRequestTextParamsInterface | AIRequestLessonParamsInterface,
}

export interface AIResponseInterface {
  result:string,
  name: AIGeneratorName,
  diff?:  {
    before: string;
    after: string;
    added: number;
    deleted: number;
    replaced: number;
  }
}

export interface IAITestRequest {
  courseId: string | number,
  sourceId: number,
  questions: number,
  variants: number,
}

export interface IAITestResponse {
  data: {
    id: number,
    course: number,
    type: string,
  }
}

async function checkResult(course_id: string|number, request: number|string): Promise<AIResponseInterface>
{
  const checkResultPromise = async (resolve: Function, reject: Function) => {
    try {
      const response = await http.get(`/api/v2/ai/request/${request}`, {params: {course_id}});
        if (response.status === 200) {
          resolve(response.data);
        }
        if (response.status === 202) {
          setTimeout(checkResultPromise, 3500, resolve, reject);
        }
    } catch(err) {
      reject(err)
    }
  }
  return new Promise(checkResultPromise);
  
}

async function generate(request:AIRequestInterface): Promise<{id:number, params:any}> {
  
  const response = await http.post('/api/v2/ai/generate',{
    name: request.name,
    source_type: request.source_type,
    source_id: request.source_id,
    data: request.data,
  }, {
    params: { course_id: request.course_id }
  });
  return response.data;
}

const ai = {
  generate,
  checkResult
};

export default ai;